/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useFlags } from 'sarsaparilla';
import LegacyInventoryReviewsSection from './LegacyInventoryReviewsSection';
import RatingsReviews from './RatingsReviews';

type PropTypes = {
    locationId: string;
    locationType: string;
    noHeading?: boolean;
    className?: string;
};

export default function InventoryReviewsSection(props: PropTypes) {
    const { ratingsReviewsRedesign } = useFlags();

    if (ratingsReviewsRedesign) {
        return <RatingsReviews {...props} />;
    }

    // @ts-expect-error — connect()/withLDConsumer() supply the rest of the props
    return <LegacyInventoryReviewsSection {...props} />;
}
